import Typography from '@mui/material/Typography';
import React from 'react';

export const CheckoutSectionTitle = ({ children, mb = 1 }: { children: React.ReactNode; mb?: number }) => {
  return (
    <Typography variant="h6" mb={mb} style={{ display: 'flex', alignItems: 'center' }}>
      {children}
    </Typography>
  );
};
